'use strict';

angular.module('internal.admin')
    .controller('InternalAdminEnterpriseDataExchange', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    }])
;